/* rozmawiajMY — galeria karty gry: przesuwanie palcem, strzałki, licznik, przewijane miniatury, klawiatura (10.10.2026) */
(function(){
  document.querySelectorAll('[data-rgal]').forEach(function(g){
    var track=g.querySelector('.rgal-track');if(!track)return;
    var slides=[].slice.call(track.children),n=slides.length;
    var cnt=g.querySelector('[data-rgal-cur]'),cap=g.querySelector('.rgal-cap');
    var thumbs=g.querySelector('.rgal-thumbs'),tb=thumbs?[].slice.call(thumbs.children):[];
    var prev=g.querySelector('.rgal-arrow.prev'),next=g.querySelector('.rgal-arrow.next');
    var tprev=g.querySelector('.rgal-tarrow.prev'),tnext=g.querySelector('.rgal-tarrow.next');
    var cur=-1;
    function go(i,instant){i=Math.max(0,Math.min(n-1,i));track.scrollTo({left:i*track.clientWidth,behavior:instant?'auto':'smooth'});}
    function showThumb(i){var t=tb[i];if(!t||!thumbs)return;var l=t.offsetLeft-thumbs.offsetLeft,r=l+t.offsetWidth;
      if(l<thumbs.scrollLeft)thumbs.scrollTo({left:l-6,behavior:'smooth'});
      else if(r>thumbs.scrollLeft+thumbs.clientWidth)thumbs.scrollTo({left:r-thumbs.clientWidth+6,behavior:'smooth'});}
    function setCur(i){if(i===cur)return;cur=i;
      if(cnt)cnt.textContent=i+1;
      if(cap){var c=slides[i].getAttribute('data-cap')||'';cap.textContent=c;cap.hidden=!c;}
      tb.forEach(function(t,k){var on=k===i;t.classList.toggle('active',on);t.setAttribute('aria-current',on?'true':'false');});
      if(prev)prev.disabled=i===0;if(next)next.disabled=i===n-1;
      showThumb(i);}
    var raf;
    track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){if(track.clientWidth)setCur(Math.round(track.scrollLeft/track.clientWidth));});},{passive:true});
    if(prev)prev.addEventListener('click',function(){go(cur-1);});
    if(next)next.addEventListener('click',function(){go(cur+1);});
    tb.forEach(function(t,k){t.addEventListener('click',function(){go(k);});});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();go(cur-1);}else if(e.key==='ArrowRight'){e.preventDefault();go(cur+1);}});
    function tState(){if(!thumbs)return;var over=thumbs.scrollWidth>thumbs.clientWidth+2;g.classList.toggle('rgal-tover',over);
      if(tprev)tprev.disabled=thumbs.scrollLeft<=2;if(tnext)tnext.disabled=thumbs.scrollLeft+thumbs.clientWidth>=thumbs.scrollWidth-2;}
    if(thumbs)thumbs.addEventListener('scroll',function(){requestAnimationFrame(tState);},{passive:true});
    if(tprev)tprev.addEventListener('click',function(){thumbs.scrollBy({left:-thumbs.clientWidth*.8,behavior:'smooth'});});
    if(tnext)tnext.addEventListener('click',function(){thumbs.scrollBy({left:thumbs.clientWidth*.8,behavior:'smooth'});});
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){go(cur,true);tState();},120);});
    setCur(0);tState();
  });
})();
